import type { RichSatellite } from '../data/types';
import type { SatelliteFilter } from '../data/types';

function matchesQuery(s: RichSatellite, q: string): boolean {
  if (!q) return true;
  const hay = [s.name, s.noradId, s.objectId, s.ownerCountry, s.kind, s.regime]
    .filter(Boolean)
    .join(' ')
    .toLowerCase();
  return hay.includes(q.toLowerCase());
}

export function applySatelliteFilter(sats: RichSatellite[], filter: SatelliteFilter): RichSatellite[] {
  return sats.filter((s) => {
    if (!matchesQuery(s, filter.query)) return false;
    if (filter.kinds.length && !filter.kinds.includes(s.kind)) return false;
    if (filter.classes.length && !filter.classes.includes(s.satelliteClass)) return false;
    if (filter.regimes.length && !filter.regimes.includes(s.regime)) return false;
    if (filter.owners.length && (!s.ownerCountry || !filter.owners.includes(s.ownerCountry))) return false;
    if (filter.altMin != null && s.altitudeKm < filter.altMin) return false;
    if (filter.altMax != null && s.altitudeKm > filter.altMax) return false;
    if (filter.speedMin != null && s.speedKmS < filter.speedMin) return false;
    if (filter.speedMax != null && s.speedKmS > filter.speedMax) return false;
    if (filter.inclMin != null && s.inclinationDeg < filter.inclMin) return false;
    if (filter.inclMax != null && s.inclinationDeg > filter.inclMax) return false;
    if (filter.periodMin != null && s.periodMin < filter.periodMin) return false;
    if (filter.periodMax != null && s.periodMin > filter.periodMax) return false;
    return true;
  });
}
